import { TicketsService } from "@/services";
import dayjs from "dayjs";
import statusChip from "@/components/TransactionsPage/StatusInTable";
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "ticket-list",
  components: { statusChip },
  data() {
    return {
      headers: [
        {
          text: this.$t("ticketsPage.ticketList.id"),
          value: "id",
          class: "table-header"
        },
        {
          text: this.$t("ticketsPage.ticketList.department"),
          value: "category",
          class: "table-header"
        },
        {
          text: this.$t("ticketsPage.ticketList.subject"),
          value: "title",
          class: "table-header"
        },
        {
          text: this.$t("ticketsPage.ticketList.lastUpdate"),
          value: "updated",
          class: "table-header"
        },
        {
          text: this.$t("ticketsPage.ticketList.status"),
          value: "status",
          class: "table-header"
        }
      ],

      itemsLength: 10,
      pageCount: 1,
      perPage: 20,
      tickets: [],
      ticketTableLoader: true,
      filterSearch: {
        page: 1,
        itemsPerPage: 20,
        driver: "jira"
      }
    };
  },

  mounted() {
    this.getTicketData();
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    })
  },
  methods: {
    getTicketData() {
      this.ticketTableLoader = true;
      TicketsService.getTickets(this.filterSearch).then(res => {
        this.ticketTableLoader = false;
        this.tickets = res.data.data;
        this.pageCount = res.data.pagination.total_pages;
        this.itemsLength = res.data.pagination.total;
        this.perPage = res.data.pagination.per_page;
      });
    },
    changeTicketData() {
      this.filterSearch.page = 1;
      this.filterSearch.itemsPerPage = 20;
      this.getTicketData();
    },
    handleClick(ticket) {
      this.$router.push({
        path: `${this.$route.path}/${ticket.id}`
      });
    },
    changePageNumber() {
      this.getTicketData();
    }
  },

  filters: {
    fromNowDate(date) {
      return dayjs(date).format("YYYY/MM/DD-HH:mm");
    }
  }
  // watch: {
  //   "filterSearch.page": function(newPage) {
  //     TicketsService.getTickets(newPage, this.filterSearch.itemsPerPage).then(
  //       res => {
  //         this.tickets = res.data.data;
  //       }
  //     );
  //   },
  //   "filterSearch.itemsPerPage": function(newPerPage) {
  //     TicketsService.getTickets(this.page, newPerPage).then(res => {
  //       this.tickets = res.data.data;
  //     });
  //   }
  // }
};
